import React from 'react';

import Close from '../../../images/Close';
import coffee from '../../../images/Coffee.png';
import Backdrop from '../../Backdrop/Backdrop';

import SignUpForm from './';

import style from './Popup.scss';

import cn from 'classnames';

const SUBSCRIBED_COOKIE_NAME = 'tsr_subscribed_at';

const isSubscribed =
  typeof document === 'undefined' ? false : document.cookie.includes(SUBSCRIBED_COOKIE_NAME);

const SignUpPopup = (props: { closeOnEscape?: boolean; closeOnExitIntent?: boolean }) => {
  const { closeOnEscape = true, closeOnExitIntent = true } = props;

  const [isShown, setIsShown] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  const handleClose = () => {
    localStorage.setItem('signup_popup_close_timeout', (new Date().getTime() + 172800).toString());

    setIsClosing(true);

    setTimeout(() => {
      setIsClosing(false);
      setIsShown(false);
    }, 300);
  };

  const handleMouseLeave = (event: any) => {
    const hiddenTimeoutDate = localStorage.getItem('signup_popup_close_timeout');

    const isOutOfWindow =
      event.clientY <= 0 ||
      event.clientX <= 0 ||
      event.clientX >= window.innerWidth ||
      event.clientY >= window.innerHeight;

    const isSubscribed = document.cookie.includes(SUBSCRIBED_COOKIE_NAME);

    if (
      // not already closed
      (!hiddenTimeoutDate ||
        (hiddenTimeoutDate &&
          new Date().getTime() - new Date(+hiddenTimeoutDate).getTime() >= 0)) &&
      isOutOfWindow &&
      !isSubscribed
    ) {
      setIsShown(true);
    }
  };

  const handleEscapeKey = (event: KeyboardEvent) => {
    event = event || window.event;
    if (event.keyCode === 27) {
      handleClose();
    }
  };

  const handleSubmit = () => {
    setTimeout(() => {
      handleClose();
    }, 1000);
  };

  React.useEffect(() => {
    const hiddenTimeoutDate = localStorage.getItem('signup_popup_close_timeout');

    if (
      isSubscribed ||
      (window && window.location.pathname === '/subscribe/') ||
      (window && window.location.pathname === '/email-subscriber-survey/')
    ) {
      setIsShown(false);
    } else if (
      !hiddenTimeoutDate ||
      (hiddenTimeoutDate && new Date().getTime() - new Date(+hiddenTimeoutDate).getTime() >= 0)
    ) {
      if (closeOnExitIntent) {
        document.addEventListener('mouseleave', handleMouseLeave);
      } else {
        setIsShown(true);
      }
    } else if (isShown) {
      setIsShown(false);
    }

    // Escape closes popup
    if (closeOnEscape) {
      document.addEventListener('onkeydown', handleEscapeKey);
    }

    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('onkeydown', handleEscapeKey);
    };
  }, []);

  return isShown ? (
    <div
      className={cn(style.animation, {
        [style.isShown]: isShown,
        [style.isClosing]: isShown && isClosing,
      })}
    >
      <Backdrop className={style.backdrop} onOutsideClick={handleClose} isOpen={isShown}>
        <div className={cn(style.popupWrapper)}>
          <div className={cn(style.popup)}>
            <div className={style.contentWrapper}>
              <img src={coffee}></img>
              <div className={style.content}>
                <h3>Wait! ✋</h3>
                <h3>Is working for someone else not working for you?</h3>
                <p>
                  It's time to change that. Subscribe to get the financial inspiration you can't
                  afford to miss.
                </p>
                <SignUpForm
                  className={style.form}
                  callBack={handleSubmit}
                  tags={['Popup', 'Exit Intent']}
                >
                  <p>Thank You!</p>
                </SignUpForm>
              </div>
            </div>
            <span className={style.close} onClick={handleClose}>
              <Close width={12} height={12} />
            </span>
          </div>
        </div>
      </Backdrop>
    </div>
  ) : null;
};

export default SignUpPopup;
